export const splitStringUUID = (ObjectUUID) => {
  const [uuid] = ObjectUUID.split("/").reverse();
  return uuid;
};
